import { DatePicker as ParentDatePicker } from "antd";
// import { Date } from "@/theme/assets/icons";

export const DatePicker = ({...rest}) => {
    return (
        <>
            <ParentDatePicker
                // className={'row-reverse'}
                suffixIcon={<Date className={'custom_icon'}/>}
                {...rest}
            />
        </>
    );
}